/* ************************************************************************ */
// Init
/* ************************************************************************ */
if (typeof SignUpGenius == 'undefined') {
    var SignUpGenius = {};
}

/* ************************************************************************ */
// Main class
/* ************************************************************************ */
SignUpGenius = {
    vars: {

    },
    tests: {
        isUsingRetina: window.devicePixelRatio > 1
    },
    config: {

    },
    main: (function() {
        return {
            init: function() {
                this.initScripts();
                this.registerEvents();
            },
            initScripts: function() {
                SignUpGenius.modals.init();
                // SignUpGenius.typed.init();
                // SignUpGenius.randomhero.init();
                //SignUpGenius.synccarousel.init();
                SignUpGenius.lazyloadimages.init();
                //SignUpGenius.loadicons.init();
                SignUpGenius.hideyshowy.init();

                $('body').addClass('ready');
            },
            registerEvents: function() {

                // Stop the hash
                $(document).on("click", "a[href='#']", function(e) {e.preventDefault();});

            },
            isTouchDevice: function() {
                return Modernizr.touch;
            },
            mobileCheck: function() {

              // Check for mobile - user agent sniffing
              window.isMobile = function() {
              var check = false;
              (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
              return check; };
              // Return results
              return isMobile();

            }
        };
    })()
};


/* ************************************************************************ */
// Init modals
/* ************************************************************************ */
SignUpGenius.modals = (function(){
    return {
        init: function() {

    		    $('.modal-inline').magnificPopup({
    				type:'inline',
    				removalDelay: 300,
    				mainClass: 'mfp-fade'
    			});

    			$('.modal-video').magnificPopup({
    				type: 'iframe',
    		        mainClass: 'mfp-fade',
    		        removalDelay: 300,
    		        tLoading: ''
    			});

    			$('.modal-iframe').magnificPopup({
    				type: 'iframe',
    		        mainClass: 'mfp-fade',
    		        removalDelay: 300,
    		        tLoading: ''
    			});

    			$('.modal-gallery').each(function() {
    				/*
    				$('.gallery-item').magnificPopup({
            			type: 'image',
    			        mainClass: 'mfp-fade',
    			        removalDelay: 300,
    			        gallery: {
    						enabled: true, // set to true to enable gallery
    						navigateByImgClick: true,
    						arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>', // markup of an arrow button
    						tPrev: 'Previous (Left arrow key)', // title for left button
    						tNext: 'Next (Right arrow key)', // title for right button
    						tCounter: '<span class="mfp-counter">%curr% of %total%</span>' // markup of counter
    					}
    				});
    				*/
    			});

    			$('.gallery-item').magnificPopup({
        			type: 'image',
    	        mainClass: 'mfp-fade tour',
    	        removalDelay: 300,
              preload: [0,1],
    	        gallery: {
      					enabled: true, // set to true to enable gallery
      					navigateByImgClick: true,
      					arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>', // markup of an arrow button
      					tPrev: 'Previous (Left arrow key)', // title for left button
      					tNext: 'Next (Right arrow key)', // title for right button
      					tCounter: '<span class="mfp-counter" style="display:none;">%curr% <span class="gamma">/</span> %total%</span>' // markup of counter
      				},
              image: {
          			tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
          			titleSrc: function(item) {
          				//return //item.el.attr('title');
          				var $gallery = $('.modal-gallery');
          				var $result = '';
          				if ($gallery.find('li').length>0) {
          					$result = '<div class="mfp-pager">' +
          						'<div class="arrow_prev" style="display:none;">' +
          							'<button type="button" class="prev arrow" onclick="javascript:$(\'.gallery\').magnificPopup(\'prev\');return false;">Previous</button>' +
          						'</div>' +
          						'<div class="dots">' +
          							'<ul class="dots">';
                					for (var i=0; i<$gallery.find('li').length; i++) {
                						var $cl_active = '';
                						if (item.index == i) $cl_active = ' class="active"'; else $cl_active = '';
                						var $thumb = $gallery.find('li:eq('+i+')').find('img').attr('src');
                						$result += '<li'+$cl_active+'>' +
                								'<a alt="Select slide" onclick="javascript:$(\'.gallery\').magnificPopup(\'goTo\', '+i+');return false;">' + i + '</a>' +
                							'</li>';
                					}
                					$result += '</ul>' +
          						'</div>' +
          						'<div class="arrow_next" style="display:none;">' +
          							'<button type="button" class="next arrow" onclick="javascript:$(\'.gallery\').magnificPopup(\'next\');return false;">Next</button>' +
          						'</div>' +
          					'</div>';
          				}
          				return $result;
          			}
          		},
    				tLoading: '<div class="preloader"><span></span><span></span><span></span><span></span><span></span></div>'
    			});

    			// From jQuery object
    			$('.gallery-item').on( "click", function(event) {
    				event.preventDefault(); // Don't scroll the browser
    			});

    			$('.gallery-trigger').on( "click", function(event) {
    				event.preventDefault();
    				$('.gallery-item').first().trigger('click');
    			});

    			$('.close-modal').click(function(){
    			    $.magnificPopup.close();
    			});


        }
    };
})();



/* ************************************************************************ */
// Google analytics helpers
/* ************************************************************************ */
SignUpGenius.lazyloadimages = (function(){
    return {
        init: function() {

            /* Lazy Load - jQuery plugin for lazy loading images */
            /* http://www.appelsiini.net/projects/lazyload */
            (function(a,b,c,d){var e=a(b);a.fn.lazyload=function(c){function i(){var b=0;f.each(function(){var c=a(this);if(h.skip_invisible&&!c.is(":visible"))return;if(!a.abovethetop(this,h)&&!a.leftofbegin(this,h))if(!a.belowthefold(this,h)&&!a.rightoffold(this,h))c.trigger("appear"),b=0;else if(++b>h.failure_limit)return!1})}var f=this,g,h={threshold:0,failure_limit:0,event:"scroll",effect:"show",container:b,data_attribute:"original",skip_invisible:!0,appear:null,load:null};return c&&(d!==c.failurelimit&&(c.failure_limit=c.failurelimit,delete c.failurelimit),d!==c.effectspeed&&(c.effect_speed=c.effectspeed,delete c.effectspeed),a.extend(h,c)),g=h.container===d||h.container===b?e:a(h.container),0===h.event.indexOf("scroll")&&g.bind(h.event,function(a){return i()}),this.each(function(){var b=this,c=a(b);b.loaded=!1,c.one("appear",function(){if(!this.loaded){if(h.appear){var d=f.length;h.appear.call(b,d,h)}a("<img />").bind("load",function(){c.hide().attr("src",c.data(h.data_attribute))[h.effect](h.effect_speed),b.loaded=!0;var d=a.grep(f,function(a){return!a.loaded});f=a(d);if(h.load){var e=f.length;h.load.call(b,e,h)}}).attr("src",c.data(h.data_attribute))}}),0!==h.event.indexOf("scroll")&&c.bind(h.event,function(a){b.loaded||c.trigger("appear")})}),e.bind("resize",function(a){i()}),/iphone|ipod|ipad.*os 5/gi.test(navigator.appVersion)&&e.bind("pageshow",function(b){b.originalEvent.persisted&&f.each(function(){a(this).trigger("appear")})}),a(b).load(function(){i()}),this},a.belowthefold=function(c,f){var g;return f.container===d||f.container===b?g=e.height()+e.scrollTop():g=a(f.container).offset().top+a(f.container).height(),g<=a(c).offset().top-f.threshold},a.rightoffold=function(c,f){var g;return f.container===d||f.container===b?g=e.width()+e.scrollLeft():g=a(f.container).offset().left+a(f.container).width(),g<=a(c).offset().left-f.threshold},a.abovethetop=function(c,f){var g;return f.container===d||f.container===b?g=e.scrollTop():g=a(f.container).offset().top,g>=a(c).offset().top+f.threshold+a(c).height()},a.leftofbegin=function(c,f){var g;return f.container===d||f.container===b?g=e.scrollLeft():g=a(f.container).offset().left,g>=a(c).offset().left+f.threshold+a(c).width()},a.inviewport=function(b,c){return!a.rightoffold(b,c)&&!a.leftofbegin(b,c)&&!a.belowthefold(b,c)&&!a.abovethetop(b,c)},a.extend(a.expr[":"],{"below-the-fold":function(b){return a.belowthefold(b,{threshold:0})},"above-the-top":function(b){return!a.belowthefold(b,{threshold:0})},"right-of-screen":function(b){return a.rightoffold(b,{threshold:0})},"left-of-screen":function(b){return!a.rightoffold(b,{threshold:0})},"in-viewport":function(b){return a.inviewport(b,{threshold:0})},"above-the-fold":function(b){return!a.belowthefold(b,{threshold:0})},"right-of-fold":function(b){return a.rightoffold(b,{threshold:0})},"left-of-fold":function(b){return!a.rightoffold(b,{threshold:0})}})})(jQuery,window,document);
            $("img.lazy").lazyload({
              effect				: "fadeIn",
              threshold			: 0,
              failure_limit : 10
            });

            // New function to replace images in carousels when sliding through - loads everything on first slide event
            jQuery.fn.extend({
              renameAttr: function( name, newName, removeData ) {
                var val;
                return this.each(function() {
                  val = jQuery.attr( this, name );
                  jQuery.attr( this, newName, val );
                  jQuery.removeAttr( this, name );
                  // remove original data
                  if (removeData !== false){
                    jQuery.removeData( this, name.replace('data-','') );
                  }
                });
              }
            });

            // Apply lazy loading to the carousel images, gets them all on first slide transition
            return $(".carousel.lazy").on("slide.bs.carousel", function(ev) {
              $(this).find("img[data-original]").renameAttr('data-original', 'src' );
            });


        }

    };
})();


/* ************************************************************************ */
// Typewriter effect for header text
/* ************************************************************************ */
// Library: http://www.mattboldt.com/demos/typed-js/
// Documentation: https://github.com/mattboldt/typed.js/
SignUpGenius.typed = (function(){
  if ($(window).width() < 768) {
    return {
        init: function() {
          var typewriter = new Typed('#typed', {
              strings: ['Group Tickets','Ticket Sales','Donations','Class Fees','School Products', 'Spirit Wear','Fundraisers','Camp Fees','Club Activities','Sporting Events','Field Trips','Photo Sessions'],
              typeSpeed: 60,
              backSpeed: 20,
              backDelay: 2000,
              startDelay: 1500,
              //shuffle: 'true',
              loop: true
            });
        }
    };
  } else {
    return {
        init: function() {
          var typewriter = new Typed('#typed', {
              strings: ['Event Registrations','Ticket Sales','Business Services','Product Sales','Fundraisers','Class Fees','Donations','Capital Campaigns','Group Tickets','School Spirit Wear','Camp Fees','Club Activities','Sporting Events','Field Trips','Photo Sessions'],
              typeSpeed: 60,
              backSpeed: 20,
              backDelay: 2000,
              startDelay: 1500,
              //shuffle: 'true',
              loop: true
            });
        }
    };
  }

})();


/* ************************************************************************ */
// Random hero image
/* ************************************************************************ */
// SignUpGenius.randomhero = (function(){
//     return {
//         init: function() {
//
//           //Create an array of the quote text you wish to show.
//           var heroImage = new Array();
//           heroImage[0] = "<img srcset='/images/collect-money/tickets-480.jpg 480w,/images/collect-money/tickets-768.jpg 768w,/images/collect-money/tickets-992.jpg 992w,/images/collect-money/tickets.jpg 1600w' sizes='(max-width: 480px) 480px,(max-width: 768px) 768px,(max-width: 992px) 992px,(max-width: 1600px) 1600px' src='/images/collect-money/tickets.jpg' alt='collect money for tickets' />";
//           heroImage[1] = "<img srcset='/images/collect-money/donations-480.jpg 480w,/images/collect-money/donations-768.jpg 768w,/images/collect-money/donations-992.jpg 992w,/images/collect-money/donations.jpg 1600w' sizes='(max-width: 480px) 480px,(max-width: 768px) 768px,(max-width: 992px) 992px,(max-width: 1600px) 1600px' src='/images/collect-money/donations.jpg' alt='donations sign ups' />";
//
//           //Then on document ready, get a new random number between 0 and the length of that array.
//           var myRandom = Math.floor(Math.random()*heroImage.length);
//
//           //Then update the blockquote (put an id="myQuote" or whatever)
//           $('#hero-image').html(heroImage[myRandom]);
//
//         }
//     };
// })();


/* ************************************************************************ */
// Synchronize carousels
/* ************************************************************************ */
// Synchronizes carousels - only the primary carousel should be running.
// The rest of the carousels with 'carousel-sync' will listen and change as needed.
SignUpGenius.synccarousel = (function(){
    return {
        init: function() {

          // Calculate a random starting spot
          var $itemHero = $('#hero-carousel .item');
          var $itemSignup = $('#signup-carousel .item');

          var $heroSlides = $('#hero-carousel .item').length;
          var $currentHeroSlide = Math.floor((Math.random() * $heroSlides));

          $itemHero.eq($currentHeroSlide).addClass('active');
          $itemSignup.eq($currentHeroSlide).addClass('active');

          // Trigger the main carousel
          $('#hero-carousel').carousel({
            interval: 5000,
            pause: "false"
          });

          // When the main carousel transitions
          $('.carousel-sync').on('slide.bs.carousel', function(ev) {
              // get the direction, based on the event which occurs
              var dir = ev.direction == 'right' ? 'prev' : 'next';
              // get synchronized non-sliding carousels, and make'em sliding
              $('.carousel-sync').not('.sliding').addClass('sliding').carousel(dir);
          });

          // When the carousel is done
          $('.carousel-sync').on('slid.bs.carousel', function(ev) {
              // remove .sliding class, to allow the next move
              $('.carousel-sync').removeClass('sliding');
          });

        }
    };
})();

SignUpGenius.hideyshowy = (function(){
    return {
        init: function() {

          //$( "#feature-group" ).hide();
          //$( "#hide-features" ).hide();

          // Simple one liner to show the feature grid
          $( "#show-features" ).click(function() {
            $( "#feature-group" ).show( "fast", function() {
              //$( ".group-five" ).removeClass("section-angle-divider");
              $( "#show-features" ).hide();
              $( "#hide-features" ).show("fast");
            });
          });

          // Simple one liner to hide the feature grid
          $( "#hide-features" ).click(function() {
            $( "#feature-group" ).hide( "fast", function() {
              //$( ".group-five" ).addClass("section-angle-divider");
              $( "#show-features" ).show("fast");
              $( "#hide-features" ).hide();
            });
          });

          // FAQ hide & show controls
          $( ".toggle-faq" ).click(function() {
            $(this).parents("article").find(".answer").slideToggle();
            $(this).parents("article").find(".answer").toggleClass("opened");
            $(this).parents("article").find(".question").toggleClass("opened");
          });

        }
    };
})();


/* ************************************************************************ */
//
/* ************************************************************************ */
$(function() {
    SignUpGenius.main.init();
});


$(document).ready(function(){
	// not used

});


/*!
 *
 *   typed.js - A JavaScript Typing Animation Library
 *   Author: Matt Boldt <me@mattboldt.com>
 *   Version: v2.0.4
 *   Url: https://github.com/mattboldt/typed.js
 *   License(s): MIT
 *
 */
(function(t,e){"object"==typeof exports&&"object"==typeof module?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.Typed=e():t.Typed=e()})(this,function(){return function(t){function e(n){if(s[n])return s[n].exports;var i=s[n]={exports:{},id:n,loaded:!1};return t[n].call(i.exports,i,i.exports,e),i.loaded=!0,i.exports}var s={};return e.m=t,e.c=s,e.p="",e(0)}([function(t,e,s){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var i=function(){function t(t,e){for(var s=0;s<e.length;s++){var n=e[s];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,s,n){return s&&t(e.prototype,s),n&&t(e,n),e}}(),r=s(1),o=s(3),a=function(){function t(e,s){n(this,t),r.initializer.load(this,s,e),this.begin()}return i(t,[{key:"toggle",value:function(){this.pause.status?this.start():this.stop()}},{key:"stop",value:function(){this.typingComplete||this.pause.status||(this.toggleBlinking(!0),this.pause.status=!0,this.options.onStop(this.arrayPos,this))}},{key:"start",value:function(){this.typingComplete||this.pause.status&&(this.pause.status=!1,this.pause.typewrite?this.typewrite(this.pause.curString,this.pause.curStrPos):this.backspace(this.pause.curString,this.pause.curStrPos),this.options.onStart(this.arrayPos,this))}},{key:"destroy",value:function(){this.reset(!1),this.options.onDestroy(this)}},{key:"reset",value:function(){var t=arguments.length<=0||void 0===arguments[0]||arguments[0];clearInterval(this.timeout),this.replaceText(""),this.cursor&&this.cursor.parentNode&&(this.cursor.parentNode.removeChild(this.cursor),this.cursor=null),this.strPos=0,this.arrayPos=0,this.curLoop=0,t&&(this.insertCursor(),this.options.onReset(this),this.begin())}},{key:"begin",value:function(){var t=this;this.typingComplete=!1,this.shuffleStringsIfNeeded(this),this.insertCursor(),this.bindInputFocusEvents&&this.bindFocusEvents(),this.timeout=setTimeout(function(){t.currentElContent&&0!==t.currentElContent.length?t.backspace(t.currentElContent,t.currentElContent.length):t.typewrite(t.strings[t.sequence[t.arrayPos]],t.strPos)},this.startDelay)}},{key:"typewrite",value:function(t,e){var s=this;this.fadeOut&&this.el.classList.contains(this.fadeOutClass)&&(this.el.classList.remove(this.fadeOutClass),this.cursor&&this.cursor.classList.remove(this.fadeOutClass));var n=this.humanizer(this.typeSpeed),i=1;return this.pause.status===!0?void this.setPauseStatus(t,e,!0):void(this.timeout=setTimeout(function(){e=o.htmlParser.typeHtmlChars(t,e,s);var n=0,r=t.substr(e);if("^"===r.charAt(0)&&/^\^\d+/.test(r)){var a=1;r=/\d+/.exec(r)[0],a+=r.length,n=parseInt(r),s.temporaryPause=!0,s.options.onTypingPaused(s.arrayPos,s),t=t.substring(0,e)+t.substring(e+a),s.toggleBlinking(!0)}if("`"===r.charAt(0)){for(;"`"!==t.substr(e+i).charAt(0)&&(i++,!(e+i>t.length)););var u=t.substring(0,e),l=t.substring(u.length+1,e+i),c=t.substring(e+i+1);t=u+l+c,i--}s.timeout=setTimeout(function(){s.toggleBlinking(!1),e===t.length?s.doneTyping(t,e):s.keepTyping(t,e,i),s.temporaryPause&&(s.temporaryPause=!1,s.options.onTypingResumed(s.arrayPos,s))},n)},n))}},{key:"keepTyping",value:function(t,e,s){0===e&&(this.toggleBlinking(!1),this.options.preStringTyped(this.arrayPos,this)),e+=s;var n=t.substr(0,e);this.replaceText(n),this.typewrite(t,e)}},{key:"doneTyping",value:function(t,e){var s=this;this.options.onStringTyped(this.arrayPos,this),this.toggleBlinking(!0),this.arrayPos===this.strings.length-1&&(this.complete(),this.loop===!1||this.curLoop===this.loopCount)||(this.timeout=setTimeout(function(){s.backspace(t,e)},this.backDelay))}},{key:"backspace",value:function(t,e){var s=this;if(this.pause.status===!0)return void this.setPauseStatus(t,e,!0);if(this.fadeOut)return this.initFadeOut();this.toggleBlinking(!1);var n=this.humanizer(this.backSpeed);this.timeout=setTimeout(function(){e=o.htmlParser.backSpaceHtmlChars(t,e,s);var n=t.substr(0,e);if(s.replaceText(n),s.smartBackspace){var i=s.strings[s.arrayPos+1];i&&n===i.substr(0,e)?s.stopNum=e:s.stopNum=0}e>s.stopNum?(e--,s.backspace(t,e)):e<=s.stopNum&&(s.arrayPos++,s.arrayPos===s.strings.length?(s.arrayPos=0,s.options.onLastStringBackspaced(),s.shuffleStringsIfNeeded(),s.begin()):s.typewrite(s.strings[s.sequence[s.arrayPos]],e))},n)}},{key:"complete",value:function(){this.options.onComplete(this),this.loop?this.curLoop++:this.typingComplete=!0}},{key:"setPauseStatus",value:function(t,e,s){this.pause.typewrite=s,this.pause.curString=t,this.pause.curStrPos=e}},{key:"toggleBlinking",value:function(t){if(this.cursor&&!this.pause.status&&this.cursorBlinking!==t){this.cursorBlinking=t;var e=t?"infinite":0;this.cursor.style.animationIterationCount=e}}},{key:"humanizer",value:function(t){return Math.round(Math.random()*t/2)+t}},{key:"shuffleStringsIfNeeded",value:function(){this.shuffle&&(this.sequence=this.sequence.sort(function(){return Math.random()-.5}))}},{key:"initFadeOut",value:function(){var t=this;return this.el.className+=" "+this.fadeOutClass,this.cursor&&(this.cursor.className+=" "+this.fadeOutClass),setTimeout(function(){t.arrayPos++,t.replaceText(""),t.strings.length>t.arrayPos?t.typewrite(t.strings[t.sequence[t.arrayPos]],0):(t.typewrite(t.strings[0],0),t.arrayPos=0)},this.fadeOutDelay)}},{key:"replaceText",value:function(t){this.attr?this.el.setAttribute(this.attr,t):this.isInput?this.el.value=t:"html"===this.contentType?this.el.innerHTML=t:this.el.textContent=t}},{key:"bindFocusEvents",value:function(){var t=this;this.isInput&&(this.el.addEventListener("focus",function(e){t.stop()}),this.el.addEventListener("blur",function(e){t.el.value&&0!==t.el.value.length||t.start()}))}},{key:"insertCursor",value:function(){this.showCursor&&(this.cursor||(this.cursor=document.createElement("span"),this.cursor.className="typed-cursor",this.cursor.innerHTML=this.cursorChar,this.el.parentNode&&this.el.parentNode.insertBefore(this.cursor,this.el.nextSibling)))}}]),t}();e["default"]=a,t.exports=e["default"]},function(t,e,s){"use strict";function n(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var r=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var s=arguments[e];for(var n in s)Object.prototype.hasOwnProperty.call(s,n)&&(t[n]=s[n])}return t},o=function(){function t(t,e){for(var s=0;s<e.length;s++){var n=e[s];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,s,n){return s&&t(e.prototype,s),n&&t(e,n),e}}(),a=s(2),u=n(a),l=function(){function t(){i(this,t)}return o(t,[{key:"load",value:function(t,e,s){if("string"==typeof s?t.el=document.querySelector(s):t.el=s,t.options=r({},u["default"],e),t.isInput="input"===t.el.tagName.toLowerCase(),t.attr=t.options.attr,t.bindInputFocusEvents=t.options.bindInputFocusEvents,t.showCursor=!t.isInput&&t.options.showCursor,t.cursorChar=t.options.cursorChar,t.cursorBlinking=!0,t.elContent=t.attr?t.el.getAttribute(t.attr):t.el.textContent,t.contentType=t.options.contentType,t.typeSpeed=t.options.typeSpeed,t.startDelay=t.options.startDelay,t.backSpeed=t.options.backSpeed,t.smartBackspace=t.options.smartBackspace,t.backDelay=t.options.backDelay,t.fadeOut=t.options.fadeOut,t.fadeOutClass=t.options.fadeOutClass,t.fadeOutDelay=t.options.fadeOutDelay,t.isPaused=!1,t.strings=t.options.strings.map(function(t){return t.trim()}),"string"==typeof t.options.stringsElement?t.stringsElement=document.querySelector(t.options.stringsElement):t.stringsElement=t.options.stringsElement,t.stringsElement){t.strings=[],t.stringsElement.style.display="none";var n=Array.prototype.slice.apply(t.stringsElement.children),i=!0,o=!1,a=void 0;try{for(var l,c=n[Symbol.iterator]();!(i=(l=c.next()).done);i=!0){var p=l.value;t.strings.push(p.innerHTML.trim())}}catch(h){o=!0,a=h}finally{try{!i&&c["return"]&&c["return"]()}finally{if(o)throw a}}}t.strPos=0,t.arrayPos=0,t.stopNum=0,t.loop=t.options.loop,t.loopCount=t.options.loopCount,t.curLoop=0,t.shuffle=t.options.shuffle,t.sequence=[],t.pause={status:!1,typewrite:!0,curString:"",curStrPos:0},t.typingComplete=!1;for(var f in t.strings)t.sequence[f]=f;t.currentElContent=this.getCurrentElContent(t),t.autoInsertCss=t.options.autoInsertCss,this.appendAnimationCss(t)}},{key:"getCurrentElContent",value:function(t){var e="";return e=t.attr?t.el.getAttribute(t.attr):t.isInput?t.el.value:"html"===t.contentType?t.el.innerHTML:t.el.textContent}},{key:"appendAnimationCss",value:function(t){if(t.autoInsertCss&&t.showCursor&&t.fadeOut){var e=document.createElement("style");e.type="text/css";var s="";t.showCursor&&(s+="\n        .typed-cursor{\n          opacity: 1;\n          animation: typedjsBlink 0.7s infinite;\n          -webkit-animation: typedjsBlink 0.7s infinite;\n                  animation: typedjsBlink 0.7s infinite;\n        }\n        @keyframes typedjsBlink{\n          50% { opacity: 0.0; }\n        }\n        @-webkit-keyframes typedjsBlink{\n          0% { opacity: 1; }\n          50% { opacity: 0.0; }\n          100% { opacity: 1; }\n        }\n      "),t.fadeOut&&(s+="\n        .typed-fade-out{\n          opacity: 0;\n          transition: opacity .25s;\n          -webkit-animation: 0;\n                  animation: 0;\n        }\n      "),0!==e.length&&(e.innerHTML=s,document.head.appendChild(e))}}}]),t}();e["default"]=l;var c=new l;e.initializer=c},function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var s={strings:["These are the default values...","You know what you should do?","Use your own!","Have a great day!"],stringsElement:null,typeSpeed:0,startDelay:0,backSpeed:0,smartBackspace:!0,shuffle:!1,backDelay:700,fadeOut:!1,fadeOutClass:"typed-fade-out",fadeOutDelay:500,loop:!1,loopCount:1/0,showCursor:!0,cursorChar:"|",autoInsertCss:!0,attr:null,bindInputFocusEvents:!1,contentType:"html",onComplete:function(t){},preStringTyped:function(t,e){},onStringTyped:function(t,e){},onLastStringBackspaced:function(t){},onTypingPaused:function(t,e){},onTypingResumed:function(t,e){},onReset:function(t){},onStop:function(t,e){},onStart:function(t,e){},onDestroy:function(t){}};e["default"]=s,t.exports=e["default"]},function(t,e){"use strict";function s(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var n=function(){function t(t,e){for(var s=0;s<e.length;s++){var n=e[s];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,s,n){return s&&t(e.prototype,s),n&&t(e,n),e}}(),i=function(){function t(){s(this,t)}return n(t,[{key:"typeHtmlChars",value:function(t,e,s){if("html"!==s.contentType)return e;var n=t.substr(e).charAt(0);if("<"===n||"&"===n){var i="";for(i="<"===n?">":";";t.substr(e+1).charAt(0)!==i&&(e++,!(e+1>t.length)););e++}return e}},{key:"backSpaceHtmlChars",value:function(t,e,s){if("html"!==s.contentType)return e;var n=t.substr(e).charAt(0);if(">"===n||";"===n){var i="";for(i=">"===n?"<":"&";t.substr(e-1).charAt(0)!==i&&(e--,!(e<0)););e--}return e}}]),t}();e["default"]=i;var r=new i;e.htmlParser=r}])});
//# sourceMappingURL=typed.min.js.map
